/**
 * @group Patient
 * @summary Patient domain repositories
 * 
 * <blockquote>
 * Exports all patient domain repositories for data access operations.
 * These repositories provide a clean abstraction layer for database operations
 * and encapsulate domain-specific data access logic for patient entities.
 * </blockquote>
 * 
 * @example
 * ```typescript
 * import { 
 *   ConsultationRepository, 
 *   PatientProfileRepository, 
 *   PatientPaymentMethodRepository 
 * } from '@shared/db';
 * 
 * const consultationRepo = new ConsultationRepository();
 * const profileRepo = new PatientProfileRepository();
 * const paymentRepo = new PatientPaymentMethodRepository();
 * ```
 */

export { ConsultationRepository } from './ConsultationRepository';
export { PatientProfileRepository } from './PatientProfileRepository';
export { PatientPaymentMethodRepository } from './PatientPaymentMethodRepository';
